import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import BranchTable from './BranchTable';
import SharedButton from '../../components/Shared/SharedButton';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function BranchMain() {
  const { t } = useTranslation();
  const { data: branchData, loading, executeFetch } = useFetchData();
  const navigate = useNavigate();

  useEffect(() => {
    executeFetch("POST", "listBranches", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "listBranches", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "listBranches", { page: 1, per_page: 10 });
  };

  return (
    <>
      <div className='flex justify-end mb-2'>
        <SharedButton
          label={t('CreateBranch')}
          icon='pi pi-plus'
          onClick={() => navigate('/manager/branch/create')}
          className='bg-primary primary-btn'
        />
      </div>
      <BranchTable
        data={branchData}
        loading={loading}
        onPageChange={handlePageChange}
        onRefresh={handleRefresh}
      />
    </>
  );
}
